import { useEffect } from "react";
import { Languages } from "lucide-react";

let loaded = false;

export function TranslateButton() {
  useEffect(() => {
    if (loaded) return;
    loaded = true;
    window.googleTranslateElementInit = () => {
      // eslint-disable-next-line no-new
      new window.google.translate.TranslateElement({ pageLanguage: "en", autoDisplay: false }, "google_translate_element");
    };
    const s = document.createElement("script");
    s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    s.async = true;
    document.body.appendChild(s);
  }, []);
  return (
    <div data-testid="translate-button" className="gt-wrap inline-flex items-center gap-1 rounded-full border border-[color:var(--border-gold)] bg-white px-2 py-0.5" title="Language">
      <Languages className="h-3.5 w-3.5 shrink-0 text-[#7A1020]" />
      <div id="google_translate_element" />
    </div>
  );
}
